import { createAppState } from '../appState';
import { renderApp } from '../renderApp';

export function runApp() {
  const store = createAppState();

  renderApp(store);
}
